import store from "../../redux/store";
import { setCookie, setToLocalStorage } from "../cookies";
import { consentData } from './set_consent_data';
import { boundSetIsNotInitital } from "../../redux/actions/is_initial";

const updateConsent = function() {
    const {
        consent,
        cookieName,
        isInitial,
    } = store.getState();

    // changes the state only once after the user desides for first time his consent
    if (isInitial) {
        boundSetIsNotInitital();
    }

    consentData.setPurposesAllowed(consent.purposes);
    
    // set vendors to the consent data object
    // consentData.setVendorsAllowed(consent.vendors);
    
    consentData.setLastUpdated();
    setCookie(consentData.getConsentString(), cookieName, 1000 * 60 * 60 * 24 * 366);
    setToLocalStorage(consentData.getConsentString());
}

export default updateConsent;